import Glide from '@glidejs/glide';
import {
    throttle,
    addAttribute,
    keepSquare,
    getPostGrids,
    resizePostGrids,
    awaitSelector,
    watchAwaitSelector,
    create_exit,
    exit
} from './functions.js';

// Custom global jQuery scripts
jQuery(document).ready(function ($) {
    'use strict';

    // Adding equalizer to the postGrid on Support
    // if ($('.page366').length > 0) {
    //     $('#section7.postGrid').attr('data-equalizer', 'support-grid-eq-outer');
    //     $('#section7.postGrid .postGrid__wrapper').attr('data-equalizer', 'support-grid-eq-inner');
    //     $('#section7.postGrid .item1, #section7.postGrid .item4').attr('data-equalizer-watch', 'support-grid-eq-outer');
    //     $('#section7.postGrid .item2, #section7.postGrid .item3').attr('data-equalizer-watch', 'support-grid-eq-inner');
    // }

    // Foundation Init
    $(document).foundation();

    // Mobile nav toggle
    $('#nav__toggle').on('click', function () {
        $('#nav__mobile').slideToggle();
        $('#site-header').toggleClass('nav__mobile--open');
    });

    // Select all external links and add attribute target="_blank"
    // $('a').not('[href^="/"]').not(`[href^="${window.location.host}"]`).not(`[href^="${window.location.protocol}//${window.location.host}"]`).attr('target', '_blank');

    if ($("#popupHome").length) {
        setTimeout(function () {
          $("#popupHome").foundation("open");
        }, 2000);
    }
    
}(jQuery));




// Document load/ready promise, calls 'ready' method when completed
HTMLDocument.prototype.ready = function () {
    return new Promise(function (resolve, reject) {
        if (document.readyState === 'complete') {
            resolve(document);
        } else {
            document.addEventListener('DOMContentLoaded', function () {
                resolve(document);
            });
        }
    });
};

// Custom global scripts
document.ready().then(function () {

    // Creates the quick exit button logic
    create_exit();

    // Creates a custom, optimized resize event
    throttle('resize', 'optimizedResize');

    // Gets the matching post grids and their items.
    // Then passes that nested array to the resizePostGrids function.
    // This is to prevent all post grids/items from being resized,
    // which may not be desired behavior.
    getPostGrids('.page178 .section2');

    // Initial resize of slides with the "square" or "circle" setting enabled in ACF
    keepSquare('.glide__slide--square, .glide__slide--circle');


    // ============================================ //
    // =============== #DONATE #FORM ============== //
    // ============================================ //
    var donateLabels = document.querySelectorAll('.donate__radioLabel');
    var donateButton = document.querySelector('.js--donateButton');
    var donateAmount = document.querySelector('.js--amount');
    var donateFrequency;

    // Toggle active label/frequency value
    for (var i = 0; i < donateLabels.length; ++i) {
        let el = donateLabels[i];
        el.addEventListener('click', function () {
            if (document.querySelector('.donate__form .js--frequency')) {
                document.querySelector('.donate__form .js--frequency').classList.remove('js--frequency');
            }
            el.classList.add('js--frequency');
            donateFrequency = el.getAttribute('data-interval');
        });
    }

    if (donateButton) {
        donateButton.addEventListener('click', function (e) {
            e.preventDefault();
            var amount = donateAmount.value;
            var frequency = '';
            var urlValue;

            // Remove any leading/trailing whitespace
            amount = amount.replace(/\s+/g, '');

            if (donateFrequency == 'monthly') {
                frequency = '&interval=monthly';
            }

            urlValue = e.target.href + '?amount=' + amount + frequency;
            if (amount.match(/^\d+$/) || amount.match(/^\d+$/)) {
                window.location.replace(urlValue);
            }
        });
    }


    // ============================================ //
    // ========= #DONATE #FORM #SHORTCODE ========= //
    // ============================================ //

    // var customDonateForm = document.querySelector('.page366 .donate__form.shortcode');
    // if (customDonateForm) {
    //     // This is the donation form that overlaps two sections,
    //     // and was added using a shortcode.
    //
    //     // There are probably much better ways to handle this,
    //     // but this simply adds a margin to the top of the second section content
    //     var nextSection = document.querySelector('#section2 .section2__content');
    //     let h = customDonateForm.clientHeight;
    //     nextSection.style.marginTop = h + 'px';
    //
    //     window.addEventListener('load', function () {
    //         let h = customDonateForm.clientHeight;
    //         nextSection.style.marginTop = h + 'px';
    //     });
    //
    //     window.addEventListener('optimizedResize', function () {
    //         let h = customDonateForm.clientHeight;
    //         nextSection.style.marginTop = h + 'px';
    //     });
    // }

    // ============================================ //
    // ============== #SLIDER #GLIDER ============= //
    // ============================================ //

    if (document.querySelector('.glide-story')) {     
        var glideStory = document.querySelector('.glide-story');
        new Glide(glideStory, {
            type: 'carousel',
            perView: 1,
            gap: 35,
            breakpoints: {
                1000: {
                    perView: 1
                }
            }
        }).mount();
    }

    if (document.querySelector('#glide-happennigs')) {     
        // var glideHappenings = document.querySelector('.glide-happennigs');
        new Glide('#glide-happennigs', {
            type: 'carousel',
            perView: 3,
            gap: 35,
            breakpoints: {
                1330: {
                    perView: 2,
                },
                640: {
                    perView: 1,
                }
            }
        }).mount();
    }

    // window.addEventListener('load', function () {
    //     // For each post grid layout,
    //     // this resizes the post item parts (heading, text, button) so they align properly
    //     getPostGrids('.page178 .section2');
    // });

    // window.addEventListener('optimizedResize', function () {
    //     // For each post grid layout,
    //     // this resizes the post item parts (heading, text, button) so they align properly
    //     //resizePostGrids(postGrids)
    //     getPostGrids('.page178 .section2');

    //     // Keep square dimensions of post grid photos and slides
    //     // with the "square" or "circle" shape setting enabled in ACF
    //     keepSquare('.glide__slide--square, .glide__slide--circle');
    //     keepSquare('.postGrid__itemPhoto');
    // });
});

// Filter Serach
var buttonElement = document.querySelector('.alm-filter .alm-filter--text-wrap button');

if (buttonElement) {
    buttonElement.textContent = '';
} 

// nav links target blank
jQuery( ".target-blank" ).children().attr('target','_blank');

// ALM page - section below ALM anchor issue
var hash = window.location.hash;
var almSection = document.querySelector('#ajax-load-more');

if ( almSection && hash) {
    window.almComplete = function(alm) {
        var target = document.querySelector(hash);
        if (target) {
            target.scrollIntoView();
        }
    };
}
